import { BuilderConfig } from '../../types/Builder';

import BusinessHubListE_Commerce, { ALIGHT_ITEMS_TITLE, E_CommerceProps } from './business-hub-list-e-commerce';

export const BusinessHubListE_CommerceBuilderConfig = {
    name: 'Business Hub List E-Commerce',
    inputs: [
        {
            name: 'background',
            type: 'object',
            subFields: [
                {
                    name: 'backgroundColor',
                    type: 'color',
                },

                {
                    name: 'backgroundImage',
                    type: 'file',
                },
            ],
        },
        {
            name: 'content',
            type: 'object',
            subFields: [
                {
                    name: 'backgroundContent',
                    type: 'color',
                },
                {
                    name: 'title',
                    type: 'html',
                    defaultValue: '',
                },

                {
                    name: 'alignItemsTitle',
                    type: 'string',
                    enum: Object.values(ALIGHT_ITEMS_TITLE),
                    defaultValue: ALIGHT_ITEMS_TITLE.center,
                },
                {
                    name: 'maxWidthTitle',
                    type: 'number',
                    defaultValue: '',
                },

                {
                    name: 'positionPartner',
                    type: 'string',
                    enum: Object.values(ALIGHT_ITEMS_TITLE),
                    defaultValue: ALIGHT_ITEMS_TITLE.end,
                },

                {
                    name: 'items',
                    type: 'list',
                    subFields: [
                        {
                            name: 'image',
                            type: 'file',
                            defaultValue: '',
                        },
                        {
                            name: 'linkPartner',
                            type: 'string',
                            defaultValue: '',
                        },
                        {
                            name: 'ratio',
                            type: 'number',
                            helperText: 'image height / image width',
                        },
                        {
                            name: 'maxWidth',
                            type: 'number',
                        },
                        {
                            name: 'maxHeight',
                            type: 'number',
                        },
                        {
                            name: 'filterGrayScale',
                            type: 'boolean',
                        },
                    ],
                },
                {
                    name: 'backgroundItem',
                    type: 'color',
                },
                {
                    name: 'borderItem',
                    type: 'boolean',
                    defaultValue: false,
                },
                {
                    name: 'paddingContent',
                    type: 'number',
                    defaultValue: '',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<E_CommerceProps> = {
    component: BusinessHubListE_Commerce,
    config: BusinessHubListE_CommerceBuilderConfig,
};

export default builderConfig;
